module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Juvie-Classroom_BW-p-130x130q80-59467c5231042011fcbf7cb0d91abf48.jpg";